import { HttpContextToken } from '@angular/common/http';
import type { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

const CLAVE = 'vitrina.visitante';
let enMemoria: string | null = null;

/**
 * Identificador anónimo de este navegador (D-140): un número al azar que se guarda aquí, sin
 * datos de la persona. Sirve para contar cuántas personas distintas buscan algo.
 */
export function visitante(): string {
  if (enMemoria) return enMemoria;
  try {
    enMemoria = localStorage.getItem(CLAVE);
    if (!enMemoria) {
      enMemoria = crypto.randomUUID();
      localStorage.setItem(CLAVE, enMemoria);
    }
  } catch {
    enMemoria ??= crypto.randomUUID();
  }
  return enMemoria;
}

/** Quién busca en el catálogo: la tienda (por defecto) o un vendedor armando un pedido */
export const ORIGEN_BUSQUEDA = new HttpContextToken<'TIENDA' | 'VENDEDOR'>(() => 'TIENDA');

export const visitanteInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiUrl)) return next(req);
  const cabeceras: Record<string, string> = { 'X-Visitante': visitante() };
  if (req.context.get(ORIGEN_BUSQUEDA) === 'VENDEDOR') cabeceras['X-Origen-Busqueda'] = 'VENDEDOR';
  return next(req.clone({ setHeaders: cabeceras }));
};
